import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, IconButton} from "@mui/material";
import {SwapHoriz as SwapHorizontalIcon, SwapVert as SwapVerticalIcon} from "@mui/icons-material";
import {ClosableDialogTitle, VerticalDivider} from "@atttomyx/react-components";
import {ConnectionForm} from "../forms";
import {edgeService, nodeService} from "../../services";
import {forms, objects} from "@atttomyx/shared-utils";
import {ADD_NEW} from "../../constants";

const toData = (edge) => {
    return {
        sourceId: edge ? edge.sourceNodeId : null,
        targetId: edge ? edge.targetNodeId : null,
        category: null,
        label: null,
        valid: false,
    }
};

const AddConnectionDialog = (props) => {
    const { snackbar, horizontal, categories, people, edge, onCancel, onSaveNode, onSaveEdge } = props;
    const [ data, setData ] = useState(toData(edge));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const newSource = data.sourceId === ADD_NEW;
        const newTarget = data.targetId === ADD_NEW;

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const successEdge = (savedNode, savedEdge) => {
            setSaving(false);
            onSaveEdge(savedEdge);

            if (savedNode) {
                onSaveNode(savedNode);
            }
        };

        const successNode = (savedNode) => {
            const edge = {
                sourceNodeId: newSource ? savedNode.id : data.sourceId,
                targetNodeId: newTarget ? savedNode.id : data.targetId,
                category: data.category,
                label: data.label,
            };

            edgeService.createEdge(edge, (savedEdge) => successEdge(savedNode, savedEdge), failure)
        };

        if (newSource || newTarget) {
            const node = {
                imageUrl: null,
                firstName: null,
                lastName: null,
            };

            nodeService.createNode(node, successNode, failure);

        } else {
            const edge = {
                sourceNodeId: data.sourceId,
                targetNodeId: data.targetId,
                category: data.category,
                label: data.label,
            };

            edgeService.createEdge(edge, (savedEdge) => successEdge(null, savedEdge), failure)
        }
    };

    const swap = () => {
        const modified = objects.deepCopy(data);

        modified.sourceId = data.targetId;
        modified.targetId = data.sourceId;

        setData(modified);
    };

    return <Dialog
        open={true}
        aria-labelledby="add-connection-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Connection
        </ClosableDialogTitle>
        <DialogContent className="add-connection-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <ConnectionForm
                    horizontal={horizontal}
                    categories={categories}
                    people={people}
                    data={data}
                    onChange={setData}
                    allowNew={true}
                    locked={false}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <IconButton
                color="primary"
                title="Swap positions"
                disabled={!data.sourceId || !data.targetId}
                onClick={swap}
            >
                {horizontal ? <SwapHorizontalIcon/> :<SwapVerticalIcon/>}
            </IconButton>
            <VerticalDivider/>
            <Button
                color="primary"
                disabled={!data.valid || !forms.differ(toData(edge), data)}
                onClick={submitForm}
            >
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddConnectionDialog;
